import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      isDark: $props.isDark,
      gnbShow: $setup.gnbShow
    }, null, 8, ["isDark", "gnbShow"]),
    _createElementVNode("div", {
      class: _normalizeClass(["layout", [$props.isDark ? 'dark' : null]]),
      id: "layout",
      onScroll: _cache[0] || (_cache[0] = ($event: any) => ($setup.scroll($event)))
    }, [
      _createElementVNode("article", {
        class: _normalizeClass(["layout-article", $props.topPadding ? null : 'padding-top'])
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 2),
      ($props.hasFooter)
        ? (_openBlock(), _createBlock(_component_Footer, {
            key: 0,
            isDark: $props.isDark
          }, null, 8, ["isDark"]))
        : _createCommentVNode("", true)
    ], 34)
  ], 64))
}